/** Alfa Survival cart drawer recommendation engine v5 — fit first, €75 second */
(function () {
  if (window.__alfaCartDynamicV5) return;
  window.__alfaCartDynamicV5 = true;

  var cache = new Map();
  var timer = null;
  var STRONG_WINDOW = 24;

  var PATTERNS = [
    ['powerstation', /(powerstation|power station)/i],
    ['powerbank', /(powerbank|power bank|portable charger|laptop powerbank)/i],
    ['solar_panel', /(zonnepaneel|solar panel|solar charger|telefoonoplader zonne|zonne-energie oplader|zonne energie oplader)/i],
    ['radio', /(noodradio|emergency radio|\bradio\b|am\/fm)/i],
    ['headlamp', /(hoofdlamp|headlamp)/i],
    ['lighting', /(zaklamp|kampeerlamp|tentlamp|lantaarn|flashlight|lantern)/i],
    ['water_filter', /(waterfilter|water filter|filterwell|sawyer mini|water purifier)/i],
    ['water_storage', /(waterzak|watercontainer|wateropslag|jerrycan|drinkzak|water bag)/i],
    ['bottle', /(drinkfles|waterfles|water bottle)/i],
    ['first_aid', /(ehbo|first aid)/i],
    ['blanket', /(nooddeken|emergency blanket|bivy)/i],
    ['signal', /(noodfluit|fluitje|whistle|signaalfluit)/i],
    ['stove', /(kooktoestel|campingbrander|gasbrander|camping stove)/i],
    ['cookware', /(kookset|pannenset|cookware|camping cookware)/i],
    ['tent', /(^|\W)(tent|tarp)(\W|$)/i],
    ['sleep_mat', /(slaapmat|sleeping mat|luchtmatras)/i],
    ['sleep_bag', /(slaapzak|sleeping bag)/i],
    ['pillow', /(campingkussen|reiskussen|camping pillow)/i],
    ['vacuum_bag', /(vacuümzak|vacuumzak|vacuum bag)/i],
    ['vacuum_pump', /(vacuümpomp|vacuumpomp|vacuum pump)/i],
    ['levelers', /(oprijblok|oprijblokken|leveller|leveler)/i],
    ['level', /(waterpas|spirit level)/i],
    ['fan', /(ventilator|camping fan|portable fan)/i],
    ['cooler', /(koelbox|coolbox|cooler)/i],
    ['jumpstarter', /(jumpstarter|jump starter|startbooster)/i],
    ['tire_inflator', /(bandenpomp|bandencompressor|tire inflator|air compressor)/i],
    ['paracord', /paracord/i],
    ['tool', /(multitool|multi-tool|survival tool|zakmes|pocket knife)/i],
    ['navigation', /(kompas|compass)/i],
    ['bag', /(rugzak|backpack|dry bag|droogtas)/i],
    ['hygiene', /(campingdouche|douchezak|outdoor douche|shower bag)/i],
    ['firestarter', /(firestarter|vuurstarter|vuurslag)/i],
    ['rain_protection', /(poncho|regenjas|rain jacket)/i]
  ];

  var CONFLICT_KEY = {
    powerstation: 'stored_power', powerbank: 'stored_power', solar_panel: 'solar_generation',
    radio: 'radio', headlamp: 'lighting', lighting: 'lighting', water_filter: 'water_filter',
    water_storage: 'water_storage', bottle: 'bottle', first_aid: 'first_aid', blanket: 'warmth',
    signal: 'signal', stove: 'stove', cookware: 'cookware', tent: 'shelter', sleep_mat: 'sleep_mat',
    sleep_bag: 'sleep_bag', pillow: 'pillow', vacuum_bag: 'vacuum_bag', vacuum_pump: 'vacuum_pump',
    levelers: 'levelers', level: 'level', fan: 'fan', cooler: 'cooler', jumpstarter: 'jumpstarter',
    tire_inflator: 'tire_inflator', paracord: 'paracord', tool: 'tool', navigation: 'navigation',
    bag: 'bag', hygiene: 'hygiene', firestarter: 'firestarter', rain_protection: 'rain_protection'
  };

  var REL = {
    powerstation: { solar_panel: 3, headlamp: 2, lighting: 2, radio: 2 },
    powerbank: { solar_panel: 3, headlamp: 2 },
    solar_panel: { powerstation: 3, powerbank: 3 },
    radio: { headlamp: 2, lighting: 2, signal: 2, powerbank: 2, water_filter: 2, first_aid: 2 },
    headlamp: { powerstation: 2, powerbank: 2, radio: 2, tent: 2 },
    lighting: { powerstation: 2, radio: 2, tent: 2 },
    water_filter: { water_storage: 3, bottle: 3, first_aid: 2, signal: 2 },
    water_storage: { water_filter: 3, stove: 2, cookware: 2 },
    bottle: { water_filter: 3 },
    first_aid: { blanket: 3, signal: 2, radio: 2, water_filter: 2 },
    blanket: { first_aid: 3, signal: 2 },
    signal: { first_aid: 2, blanket: 2, radio: 2, water_filter: 2 },
    stove: { cookware: 3, water_storage: 2, firestarter: 2 },
    cookware: { stove: 3, water_storage: 2 },
    firestarter: { stove: 2 },
    tent: { sleep_mat: 3, sleep_bag: 3, pillow: 2, headlamp: 2, lighting: 2, paracord: 2 },
    sleep_mat: { tent: 3, sleep_bag: 2, pillow: 2 },
    sleep_bag: { tent: 3, sleep_mat: 2, pillow: 2 },
    pillow: { tent: 2, sleep_mat: 2, sleep_bag: 2 },
    vacuum_bag: { vacuum_pump: 3 }, vacuum_pump: { vacuum_bag: 3 },
    levelers: { level: 3 }, level: { levelers: 3 }, fan: { powerbank: 2 },
    jumpstarter: { tire_inflator: 3 }, tire_inflator: { jumpstarter: 3 },
    tool: { paracord: 2, navigation: 2 }, paracord: { tool: 2, tent: 2 },
    navigation: { tool: 2, signal: 2 }, rain_protection: { bag: 2 }
  };

  function digits(v) { return String(v == null ? '' : v).replace(/\D/g, ''); }
  function num(v) { var n = Number(v); return Number.isFinite(n) ? n : 0; }
  function normalize(v) { return String(v || '').toLowerCase().replace(/[_–—-]+/g, ' '); }
  function groups(blob) {
    var out = [], value = normalize(blob);
    PATTERNS.forEach(function (p) { if (p[1].test(value)) out.push(p[0]); });
    return Array.from(new Set(out));
  }
  function functionKeys(gs) { return Array.from(new Set((gs || []).map(function (g) { return CONFLICT_KEY[g] || g; }))); }
  function intersects(a, b) { return (a || []).some(function (g) { return (b || []).indexOf(g) !== -1; }); }
  function packageLike(title) { return /(noodpakket|survivalpakket|emergency kit|72\s*uur\s*(pakket|kit)|complete noodset)/i.test(String(title || '')); }
  function relation(a, b) {
    if (!a.length || !b.length) return 0;
    var best = 0;
    a.forEach(function (x) { b.forEach(function (y) { best = Math.max(best, num((REL[x] || {})[y]), num((REL[y] || {})[x])); }); });
    return best;
  }
  function strategy(url) {
    try { return new URL(url || '', location.origin).searchParams.get('pr_prod_strat') || ''; }
    catch (e) { return ''; }
  }
  function rootUrl() {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    return r.endsWith('/') ? r : r + '/';
  }
  function fetchRecs(id, intent) {
    var key = id + ':' + intent;
    if (cache.has(key)) return cache.get(key);
    var req = fetch(rootUrl() + 'recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=10&intent=' + intent, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (p) { return Array.isArray(p && p.products) ? p.products : []; })
      .catch(function () { return []; });
    cache.set(key, req);
    return req;
  }
  function availableVariant(p) {
    if (!p || !Array.isArray(p.variants)) return null;
    return p.variants.find(function (v) { return v && v.available; }) || null;
  }
  function imageUrl(p, v) {
    var x = v && v.featured_image || p && p.featured_image || p && p.images && p.images[0];
    if (!x) return '';
    if (typeof x === 'string') return x;
    return x.src || x.url || '';
  }
  function productIdentityBlob(p) {
    return [p && p.title, p && p.type, p && Array.isArray(p.tags) ? p.tags.join(' ') : ''].filter(Boolean).join(' ');
  }
  function readCart(root) {
    var triggers = new Map(), cartIds = new Set(), cartFunctions = new Set();
    root.querySelectorAll('[data-cd-trigger-seed]').forEach(function (n) {
      var id = digits(n.dataset.productId);
      if (!id) return;
      var gs = groups([n.dataset.title, n.dataset.type, n.dataset.tags].filter(Boolean).join(' '));
      var fns = functionKeys(gs);
      triggers.set(id, { id: id, title: n.dataset.title || '', groups: gs, functions: fns });
      cartIds.add(id);
      fns.forEach(function (fn) { cartFunctions.add(fn); });
    });
    return { triggers: triggers, ids: cartIds, functions: Array.from(cartFunctions) };
  }
  function cartSignature(root, cart) {
    return Array.from(cart.ids).sort().join(',') + '|' + String(root.dataset.cartTotal || '') + '|' + String(root.dataset.shippingThreshold || '');
  }

  // Hard floor: unknown function, exact product, package-like product or any same-function cart duplicate = reject.
  function hardFit(trigger, candidateGroups, candidateFunctions, title, cart, source, isCopurchase) {
    if (!trigger || !trigger.groups.length || !candidateGroups.length || !candidateFunctions.length || packageLike(title)) return 0;
    if (intersects(candidateFunctions, cart.functions)) return 0;

    var manual = relation(trigger.groups, candidateGroups);
    if (manual >= 2) return manual;

    // Shopify complementary data and explicit co-purchase are accepted as fit evidence,
    // but only after the hard duplicate/function gate above has passed.
    if (isCopurchase) return 3;
    if (source === 'complementary') return 2;
    return 0;
  }
  function bundleConnected(triggerGroups, itemGroups) {
    var nodes = [triggerGroups].concat(itemGroups), seen = new Set([0]), queue = [0];
    while (queue.length) {
      var current = queue.shift();
      for (var i = 0; i < nodes.length; i += 1) {
        if (seen.has(i)) continue;
        if (relation(nodes[current], nodes[i]) >= 2) { seen.add(i); queue.push(i); }
      }
    }
    return seen.size === nodes.length;
  }
  function validateBundle(node, cart) {
    var trigger = cart.triggers.get(digits(node.dataset.triggerId));
    if (!trigger || !trigger.groups.length) return false;
    var itemNodes = Array.from(node.querySelectorAll('[data-cd-bundle-item]'));
    if (itemNodes.length < 2 || itemNodes.length > 3) return false;
    var seenIds = new Set(), seenFunctions = [], itemGroups = [];
    for (var i = 0; i < itemNodes.length; i += 1) {
      var n = itemNodes[i], id = digits(n.dataset.productId);
      if (!id || seenIds.has(id) || cart.ids.has(id)) return false;
      var gs = groups([n.dataset.title, n.dataset.type, n.dataset.tags].filter(Boolean).join(' '));
      var fns = functionKeys(gs);
      if (!gs.length || !fns.length || packageLike(n.dataset.title)) return false;
      if (intersects(fns, cart.functions)) return false;
      if (seenFunctions.some(function (existing) { return intersects(fns, existing); })) return false;
      seenIds.add(id); seenFunctions.push(fns); itemGroups.push(gs);
    }
    return bundleConnected(trigger.groups, itemGroups);
  }
  function selectValidBundle(root, cart) {
    var candidates = Array.from(root.querySelectorAll('[data-cd-bundle-candidate]')), winner = null;
    candidates.forEach(function (node) {
      var valid = !winner && validateBundle(node, cart);
      node.hidden = !valid;
      if (valid) winner = node;
    });
    return winner;
  }
  function merge(pool, d) {
    var id = digits(d.productId);
    if (!id || d.fitStrength < 2) return;
    var c = pool.get(id);
    if (!c) {
      c = { productId:id, variantId:digits(d.variantId), title:d.title || '', url:d.url || '', image:d.image || '',
        price:num(d.price), compareAtPrice:num(d.compareAtPrice), groups:d.groups || [], functions:d.functions || [],
        fitStrength:num(d.fitStrength), relatedRank:Number.isFinite(d.relatedRank) ? d.relatedRank : null,
        copurchase:!!d.copurchase, complementary:!!d.complementary, origins:new Set() };
      pool.set(id, c);
    } else {
      c.fitStrength = Math.max(c.fitStrength, num(d.fitStrength));
      c.copurchase = c.copurchase || !!d.copurchase;
      c.complementary = c.complementary || !!d.complementary;
      c.compareAtPrice = Math.max(c.compareAtPrice, num(d.compareAtPrice));
      if (Number.isFinite(d.relatedRank)) c.relatedRank = c.relatedRank == null ? d.relatedRank : Math.min(c.relatedRank, d.relatedRank);
    }
    if (d.triggerId) c.origins.add(digits(d.triggerId));
  }
  function addProduct(pool, p, trigger, source, rank, relatedInfo, cart) {
    if (!p || !p.available || !trigger) return;
    var id = digits(p.id);
    if (!id || cart.ids.has(id) || packageLike(p.title)) return;
    var v = availableVariant(p);
    if (!v || num(v.price) <= 0) return;

    var gs = groups(productIdentityBlob(p)), fns = functionKeys(gs);
    var isCopurchase = !!(relatedInfo && relatedInfo.strategy === 'copurchase');
    var relatedRank = relatedInfo && Number.isFinite(relatedInfo.rank) ? relatedInfo.rank : null;
    var fit = hardFit(trigger, gs, fns, p.title, cart, source, isCopurchase);
    if (fit < 2) return;

    // Ordinary related products need either manual fit or a high Shopify rank.
    if (source === 'related' && !isCopurchase && relation(trigger.groups, gs) < 2) return;
    if (source === 'related' && !isCopurchase && (relatedRank == null || relatedRank > 4)) return;

    merge(pool, { triggerId:trigger.id, productId:id, variantId:v.id, title:p.title, url:p.url, image:imageUrl(p,v),
      price:v.price, compareAtPrice:v.compare_at_price, groups:gs, functions:fns, fitStrength:fit,
      relatedRank:relatedRank, copurchase:isCopurchase, complementary:source === 'complementary' });
  }
  function quality(c) {
    var q = c.fitStrength * 15;
    if (c.copurchase) q += 120;
    if (c.complementary) q += 40;
    if (c.relatedRank != null) q += Math.max(4, 32 - c.relatedRank * 4);
    q += Math.min(18, Math.max(0, c.origins.size - 1) * 9);
    return q;
  }
  function pairCompatible(a, b) { return !intersects(a.functions || [], b.functions || []); }
  function byQuality(a, b) {
    var d = quality(b) - quality(a);
    if (Math.abs(d) > 0.001) return d;
    if (a.fitStrength !== b.fitStrength) return b.fitStrength - a.fitStrength;
    return a.price - b.price;
  }

  // Relevance selects the pool and anchor. €75 only decides whether a second strong candidate is added.
  function choose(candidates, cartTotal, threshold) {
    if (!candidates.length) return [];
    var sorted = candidates.slice().sort(byQuality);
    var bestQ = quality(sorted[0]);
    var strong = sorted.filter(function (c) { return quality(c) >= bestQ - STRONG_WINDOW; }).slice(0, 6);
    var anchor = strong[0];
    if (!anchor) return [];

    if (!threshold || cartTotal >= threshold || cartTotal + anchor.price >= threshold) return [anchor];

    var seconds = strong.slice(1).filter(function (c) { return pairCompatible(anchor, c); });
    if (!seconds.length) return [anchor];

    var reaching = seconds.filter(function (c) { return cartTotal + anchor.price + c.price >= threshold; });
    if (reaching.length) {
      reaching.sort(function (a, b) {
        var overA = cartTotal + anchor.price + a.price - threshold;
        var overB = cartTotal + anchor.price + b.price - threshold;
        if (overA !== overB) return overA - overB;
        return byQuality(a, b);
      });
      return [anchor, reaching[0]];
    }

    // No strong pair can reach €75: still allow a second genuinely strong complement,
    // choosing the one that closes the gap most without weakening relevance below the strong pool.
    seconds.sort(function (a, b) {
      if (a.price !== b.price) return b.price - a.price;
      return byQuality(a, b);
    });
    return [anchor, seconds[0]];
  }
  function formatter(currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style:'currency', currency:currency || 'EUR', minimumFractionDigits:2, maximumFractionDigits:2 }); }
    catch (e) { return new Intl.NumberFormat('nl-NL', { style:'currency', currency:'EUR', minimumFractionDigits:2, maximumFractionDigits:2 }); }
  }
  function buildCard(c, label, money) {
    var item = document.createElement('div');
    item.className = 'cd-upsell__item'; item.setAttribute('role','listitem');
    item.dataset.upsellProductId = c.productId; item.dataset.upsellSource = c.complementary ? 'complementary' : 'related';
    item.dataset.recommendationStrength = c.copurchase ? 'copurchase' : 'relevant'; item.dataset.fitStrength = String(c.fitStrength);
    var wrap = document.createElement('div'); wrap.className = 'cd-upsell__card';
    var a = document.createElement('a'); a.className='cd-upsell__thumb'; a.href=c.url || '#'; a.tabIndex=-1;
    if (c.image) { var img=document.createElement('img'); img.src=c.image; img.width=46; img.height=46; img.alt=c.title || ''; img.loading='lazy'; a.appendChild(img); }
    var info=document.createElement('div'); info.className='cd-upsell__info';
    var title=document.createElement('a'); title.className='cd-upsell__title'; title.href=c.url || '#'; title.textContent=c.title || '';
    var price=document.createElement('span'); price.className='cd-upsell__price'; price.appendChild(document.createTextNode(money.format(c.price/100)));
    if (c.compareAtPrice > c.price) { var compare=document.createElement('span'); compare.className='cd-upsell__compare'; compare.textContent=money.format(c.compareAtPrice/100); price.appendChild(compare); }
    info.appendChild(title); info.appendChild(price);
    var button=document.createElement('button'); button.type='button'; button.className='cd-upsell__add'; button.setAttribute('data-cd-add',c.variantId); button.setAttribute('aria-label',label+': '+(c.title || ''));
    button.innerHTML='<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg><span></span>'; button.querySelector('span').textContent=label;
    wrap.appendChild(a); wrap.appendChild(info); wrap.appendChild(button); item.appendChild(wrap); return item;
  }
  function renderDynamic(slot, selected) {
    slot.replaceChildren();
    if (!selected.length || !slot.isConnected) return;
    var wrap=document.createElement('div'); wrap.className='cd-upsell cd-upsell--loose'; wrap.dataset.upsellSource='dynamic';
    var heading=document.createElement('p'); heading.className='cd-upsell__head'; heading.textContent=slot.dataset.heading || 'MAAKT JE UITRUSTING COMPLEET';
    var list=document.createElement('div'); list.className='cd-upsell__list'; list.setAttribute('role','list');
    var money=formatter(slot.dataset.currency), label=slot.dataset.addLabel || 'Voeg toe';
    selected.forEach(function(c){ list.appendChild(buildCard(c,label,money)); });
    wrap.appendChild(heading); wrap.appendChild(list); slot.appendChild(wrap);
  }
  async function initRoot(root) {
    if (!root || root.dataset.cdLoading === '1') return;

    var cart=readCart(root), signature=cartSignature(root, cart);
    if (root.dataset.cdSignature === signature && root.dataset.cdReady) return;

    root.dataset.cdLoading='1';
    root.dataset.cdSignature=signature;
    delete root.dataset.cdReady;

    var slot=root.querySelector('[data-cd-dynamic-recs]');
    if (!slot) { delete root.dataset.cdLoading; return; }
    slot.replaceChildren();

    var bundle=selectValidBundle(root,cart);
    if (bundle) { delete root.dataset.cdLoading; root.dataset.cdReady='bundle'; return; }

    var usable=Array.from(cart.triggers.values()).filter(function(t){ return t.groups.length>0; });
    if (!usable.length) { delete root.dataset.cdLoading; root.dataset.cdReady='empty'; return; }

    var rows=await Promise.all(usable.map(async function(trigger){
      var result=await Promise.all([fetchRecs(trigger.id,'complementary'),fetchRecs(trigger.id,'related')]);
      return { trigger:trigger, complementary:result[0], related:result[1] };
    }));
    if (!root.isConnected) return;

    // Cart can change while recommendation requests are in flight. Never render stale results.
    var freshCart=readCart(root), freshSignature=cartSignature(root, freshCart);
    if (freshSignature !== signature) {
      delete root.dataset.cdLoading;
      delete root.dataset.cdReady;
      root.dataset.cdSignature=freshSignature;
      schedule();
      return;
    }

    var pool=new Map();
    rows.forEach(function(row){
      var relatedMap=new Map();
      row.related.forEach(function(p,rank){ relatedMap.set(digits(p.id),{rank:rank,strategy:strategy(p.url)}); });
      row.complementary.forEach(function(p,rank){ addProduct(pool,p,row.trigger,'complementary',rank,relatedMap.get(digits(p.id)),cart); });
      row.related.forEach(function(p,rank){ addProduct(pool,p,row.trigger,'related',rank,{rank:rank,strategy:strategy(p.url)},cart); });
    });

    var candidates=Array.from(pool.values()).filter(function(c){
      return c.variantId && c.price>0 && c.fitStrength>=2 && !cart.ids.has(c.productId) && !intersects(c.functions,cart.functions);
    });
    var selected=choose(candidates,num(root.dataset.cartTotal),num(root.dataset.shippingThreshold));
    renderDynamic(slot,selected);
    root.dataset.cdReady=selected.length ? 'dynamic' : 'empty';
    delete root.dataset.cdLoading;
  }
  function initAll(){ document.querySelectorAll('#CartDrawer [data-cd-recommendation-root]').forEach(initRoot); }
  function schedule(){ clearTimeout(timer); timer=setTimeout(initAll,60); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll,{once:true}); else initAll();
  document.addEventListener('cart:updated',schedule);
  document.addEventListener('cart:refresh',function(){ setTimeout(initAll,140); });
  function observe(){
    var drawer=document.getElementById('CartDrawer');
    if(!drawer || drawer.__alfaDynamicV5Observer) return;
    drawer.__alfaDynamicV5Observer=true;
    new MutationObserver(schedule).observe(drawer,{childList:true,subtree:true}); initAll();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',observe,{once:true}); else observe();
})();
